import Immutable from 'immutable';
import { QUOTED } from 'pu-data/QuoteSteps';

const state = {
  quote: Spree.quote,
};

if (Spree.quote_parameters) {
  state.parameters = Spree.quote_parameters;
}

if (Spree.quote && Spree.quote.line_items && Spree.quote.line_items[0]) {
  state.parameters.quantities = Spree.quote.line_items[0].quantities;
}

export default Immutable.fromJS(state);
